import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { whatsappLink } from '../data/mock';

const FinalCTA = ({ onScrollToForm }) => {
  return (
    <section className="final-cta-section block-light">
      <div className="container">
        <div className="final-cta-content">
          <h2>¿Listo para sentirte mejor de forma simple?</h2>
          <p>
            Escríbenos y te orientamos según tu objetivo. Atención inmediata por WhatsApp y envíos a todo el país.
          </p>
          <div className="cta-buttons-vertical">
            <a 
              href={whatsappLink} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-contact-cta"
            >
              <MessageCircle size={20} />
              Contáctanos
            </a>
            <Button 
              className="btn-guide-outline" 
              onClick={onScrollToForm}
            >
              Recibe tu guía gratuita
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;